import * as React from 'react'
import styled from 'styled-components'
import { tJa } from '../../../core/i18n'
import * as constants from '../../../static/constants'
import SvgIcon from '../../atoms/SvgIcon'

// DMCツアーのツアー情報画面・ゲスト情報画面で共通の枠(ステップ表示・本文・フッター)
// 配色・寸法はモック(tour/Main.dc.html, guest/Guest.dc.html)に合わせて直接指定

const STEP_KEYS = ['step_tour', 'step_guests', 'step_assign']

// current: 現在のステップ(0=ツアー情報, 1=ゲスト情報)
export const DmcSteps: React.FC<{ current: number }> = ({ current }) => (
  <Steps>
    {STEP_KEYS.map((key, index) => {
      const state = index < current ? 'done' : index === current ? 'active' : undefined
      return (
        <li key={key} className={state}>
          <span className="num">
            {state === 'done' ? <SvgIcon name="check" width={16} height={16} /> : index + 1}
          </span>
          <span className="label">{tJa(`dmc_tour.${key}`)}</span>
          {index < STEP_KEYS.length - 1 && <span className="line" />}
        </li>
      )
    })}
  </Steps>
)

export const Wrapper = styled.div`
  min-height: calc(100vh - ${constants.HEADER_HEIGHT + constants.FOOTER_HEIGHT}px);
  background-color: ${constants.COLORS.background};
`

export const PageHead = styled.div`
  padding: 32px 40px 0;

  h1 {
    margin: 0;
    font-size: 22px;
    font-weight: bold;
    color: ${constants.COLORS.black};
  }

  @media (max-width: ${constants.BREAKPOINT_DESKTOP}px) {
    padding: 16px 12px 0;
  }
`

export const Main = styled.div`
  padding: 24px 40px 80px;

  @media (max-width: ${constants.BREAKPOINT_DESKTOP}px) {
    padding: 16px 12px;
  }
`

const Steps = styled.ol`
  display: flex;
  margin: 0 0 24px;
  padding: 16px 24px;
  list-style: none;
  background-color: ${constants.COLORS.white};
  border: 1px solid ${constants.COLORS.divider2};
  border-radius: 6px;

  li {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 13px;
    color: ${constants.COLORS.subText};

    &:not(:last-child) {
      flex: 1;
    }

    &.active {
      .num {
        color: ${constants.COLORS.white};
        background-color: ${constants.COLORS.primary};
        border-color: ${constants.COLORS.primary};
      }

      .label {
        color: ${constants.COLORS.primary};
        font-weight: bold;
      }
    }

    &.done {
      .num {
        color: ${constants.COLORS.success};
        background-color: ${constants.COLORS.successBG};
        border-color: ${constants.COLORS.successBG};
      }

      .label {
        color: ${constants.COLORS.successText};
      }
    }
  }

  .num {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 26px;
    height: 26px;
    font-size: 12px;
    font-weight: bold;
    border: 1px solid ${constants.COLORS.divider2};
    border-radius: 50%;
    background-color: ${constants.COLORS.white};
  }

  .line {
    flex: 1;
    height: 1px;
    margin: 0 16px;
    background-color: ${constants.COLORS.divider2};
  }
`

export const Footer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 12px;
  padding: 18px 24px;
  background-color: ${constants.COLORS.white};
  border: 1px solid ${constants.COLORS.divider2};
  border-radius: 6px;

  // ボタンを全て右寄せにする(ツアー情報画面: 保存 → ゲスト情報へ)
  &.end {
    justify-content: flex-end;
  }

  .Button {
    display: inline-flex;
    align-items: center;
    gap: 6px;
  }
`
